import { useTranslation } from 'react-i18next';
import { Flex, FormProvider } from 'dash-ui';
import { Navigate } from 'react-router-dom';

import { RoutesPath } from 'flow-components/routes/routes';

import SettingsSection from 'pages/ProfilePage/components/ProfileSettings/components/SettingsSection/SettingsSection';
import UpdatePasswordForm from 'pages/ProfilePage/components/ProfileSettings/components/UpdatePasswordForm/UpdatePasswordForm';
import { FormFieldsList as UpdatePasswordFormFieldsList } from 'pages/ProfilePage/components/ProfileSettings/components/UpdatePasswordForm/constants/constants';
import UpdateEmailForm from 'pages/ProfilePage/components/ProfileSettings/components/UpdateEmailForm/UpdateEmailForm';
import { FormFieldsList as UpdateEmailFormFieldsList } from 'pages/ProfilePage/components/ProfileSettings/components/UpdateEmailForm/constants/constants';
import { ProfileTabsKeys } from 'pages/ProfilePage/ProfilePage.constants';

function ProfileSettings({
  isSubscriptionActive,
}: {
  isSubscriptionActive?: boolean | null;
}) {
  const { t } = useTranslation(['pages']);

  if (!isSubscriptionActive) {
    return (
      <Navigate
        to={`${RoutesPath.Profile}?tab=${ProfileTabsKeys.ACCOUNT_INFO}`}
      />
    );
  }

  return (
    <Flex w="100%" flexDirection="column">
      <SettingsSection
        title={t('pages:profilePage:settings:updateEmailTitle')}
        subtitle={t('pages:profilePage:settings:updateEmailSubTitle')}
        isEmail
      >
        {(close) => (
          <FormProvider fieldsList={UpdateEmailFormFieldsList}>
            <UpdateEmailForm onSuccess={close} />
          </FormProvider>
        )}
      </SettingsSection>
      <SettingsSection
        title={t('pages:profilePage:settings:updatePassword')}
        subtitle={t('pages:profilePage:settings:updatePasswordSubTitle')}
      >
        {(close) => (
          <FormProvider fieldsList={UpdatePasswordFormFieldsList}>
            <UpdatePasswordForm onSuccess={close} />
          </FormProvider>
        )}
      </SettingsSection>
    </Flex>
  );
}

export default ProfileSettings;
